// 药品展示网站占位图片

// 这些是药品网站可以使用的占位图片URL
// 实际项目中应该替换为真实的药品图片

export const placeholderImages = {
  // 药品图片占位符
  med1: 'https://via.placeholder.com/300x200/3a8ee6/FFFFFF?text=药品图片1',
  med2: 'https://via.placeholder.com/300x200/42b983/FFFFFF?text=药品图片2',
  med3: 'https://via.placeholder.com/300x200/e74c3c/FFFFFF?text=药品图片3',
  med4: 'https://via.placeholder.com/300x200/f39c12/FFFFFF?text=药品图片4',
  
  // 其他图片占位符
  company: 'https://via.placeholder.com/600x400/3a8ee6/FFFFFF?text=公司形象',
  qrcode: 'https://via.placeholder.com/150x150/ffffff/000000?text=扫码关注',
  honor: 'https://via.placeholder.com/300x200/f1c40f/FFFFFF?text=企业荣誉',
  
  // 轮播图占位符
  banner1: 'https://via.placeholder.com/800x400/3a8ee6/FFFFFF?text=康泰药业',
  banner2: 'https://via.placeholder.com/800x400/42b983/FFFFFF?text=健康生活',
  banner3: 'https://via.placeholder.com/800x400/e74c3c/FFFFFF?text=质量保障'
};

export default placeholderImages;